import { render, staticRenderFns } from "./VCookies.vue?vue&type=template&id=0af07754&scoped=true"
import script from "./VCookies.vue?vue&type=script&lang=js"
export * from "./VCookies.vue?vue&type=script&lang=js"
import style0 from "./VCookies.vue?vue&type=style&index=0&id=0af07754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af07754",
  null
  
)

export default component.exports